const testimonials = [
  {
    name: '小雨',
    location: '上海',
    comment: '关注长日光阴快一年了，它改变了我的生活方式。以前总觉得周末要安排得很满才算"不浪费"，现在学会了什么都不做地坐在阳台上喝茶，反而觉得更充实。',
    avatar: 'https://readdy.ai/api/search-image?query=Soft%20portrait%20of%20a%20young%20Chinese%20woman%20with%20warm%20smile%2C%20natural%20lighting%2C%20cream%20background%2C%20minimalist%20style%2C%20gentle%20expression%2C%20fine%20art%20portrait%20photography&width=200&height=200&seq=avatar-xiaoyu&orientation=squarish',
  },
  {
    name: '老张',
    location: '成都',
    comment: '作为一个在互联网行业加班十年的人，长日光阴让我重新思考了什么是"好生活"。现在每天早上花半小时给自己泡杯茶，一整天的心态都不一样了。',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20a%20middle-aged%20Chinese%20man%20with%20kind%20eyes%2C%20natural%20lighting%2C%20cream%20background%2C%20minimalist%20style%2C%20calm%20expression%2C%20fine%20art%20portrait%20photography&width=200&height=200&seq=avatar-laozhang&orientation=squarish',
  },
  {
    name: '阿树',
    location: '杭州',
    comment: '最喜欢"时光记录"这个栏目，教会了我用胶片相机。拍出来的照片虽然不完美，但每一张都有温度。感谢长日光阴，让我学会了等待和珍惜。',
    avatar: 'https://readdy.ai/api/search-image?query=Soft%20portrait%20of%20a%20young%20Chinese%20person%20with%20gentle%20smile%2C%20natural%20lighting%2C%20cream%20background%2C%20minimalist%20style%2C%20thoughtful%20expression%2C%20fine%20art%20portrait%20photography&width=200&height=200&seq=avatar-ashu&orientation=squarish',
  },
  {
    name: '茉莉',
    location: '深圳',
    comment: '孕期开始关注长日光阴，现在宝宝一岁了，每天睡前都会翻一篇文章。那种温暖的文字总能让我在带娃的疲惫中找到一片宁静。',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20a%20young%20Chinese%20woman%20with%20gentle%20smile%2C%20natural%20lighting%2C%20cream%20background%2C%20minimalist%20style%2C%20soft%20expression%2C%20fine%20art%20portrait%20photography&width=200&height=200&seq=avatar-moli&orientation=squarish',
  },
];

export default function Reputation() {
  return (
    <section id="reputation" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mb-3">
            读者的声音
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto leading-relaxed">
            五十万读者的真心话，是我们继续前行的最大动力
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-background-50 rounded-lg p-5 md:p-6">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{t.name}</p>
                  <p className="text-xs text-foreground-400 whitespace-nowrap">{t.location}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                "{t.comment}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}